// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2YvTq","alertIcon":"ConfirmModal_alertIcon__3omUz"};